import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  ORGANISATIONS_QUERY_KEY,
  USER_PROFILE_QUERY_KEY,
} from 'constants/queryKeys';
import OrganisationsService from 'services/OrganisationsService';

export const useDeleteOrganisation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => OrganisationsService.DeleteOrganisation(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ORGANISATIONS_QUERY_KEY] });
      // Also invalidate user profile — org deletion affects membership counts
      queryClient.invalidateQueries({ queryKey: [USER_PROFILE_QUERY_KEY] });
    },
  });
};

export default useDeleteOrganisation;
